<script>
import ApplicationList from '@/views/ExtendableBases/ApplicationList/'

export default {
  extends: ApplicationList
}
</script>
